import { useState } from "react";
import ResponsiveImage from "../../components/shared/ResponsiveImage.jsx";

/**
 * Team card: shows a normal portrait by default, swaps to a LARP-costume
 * shot on hover (CSS crossfade — see .tl-team-photo* in global.css). The
 * hover photo isn't mounted until the first hover/focus — even optimized,
 * there's no reason to make every visitor download a photo most of them
 * will never trigger. Falls back to the placeholder diagonal pattern when
 * no photo exists yet.
 */
export default function TeamTile({ member, rolePlaceholder }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="tl-card-light" style={{ display: "flex", flexDirection: "column", gap: "14px", padding: "22px" }}>
      {member.photo ? (
        <div
          className="tl-team-photo"
          style={{ position: "relative", height: "150px", borderRadius: "8px", overflow: "hidden" }}
          onMouseEnter={() => setHovered(true)}
          onFocus={() => setHovered(true)}
        >
          <ResponsiveImage
            src={member.photo}
            alt={member.name}
            className="tl-team-photo-base"
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
          {member.hoverPhoto && hovered && (
            <ResponsiveImage
              src={member.hoverPhoto}
              alt=""
              aria-hidden="true"
              className="tl-team-photo-hover"
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}
        </div>
      ) : (
        <div className="tl-diagonal-light" style={{ height: "150px", borderRadius: "8px" }} />
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
        <span style={{ fontFamily: "var(--font-serif)", fontSize: "18px", color: "var(--color-ink)" }}>{member.name ?? "—"}</span>
        <span style={{ fontSize: "13px", color: "rgba(10,9,7,0.6)" }}>{member.role ?? rolePlaceholder}</span>
      </div>
    </div>
  );
}
